import { DndContext, KeyboardSensor, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { arrayMove, SortableContext, sortableKeyboardCoordinates } from '@dnd-kit/sortable';
import React, { useEffect, useMemo, useState } from 'react';
import { SortableOverlay } from './SortableOverlay';

type ContentListItemProps = {
	items: any[];
	onChange: (_items: any[]) => void;
	renderItem: (_item: any, _expandedId?: string, _setExpandedId?: (_id: string) => void) => React.ReactNode;
};
const ContentListItem = ({ items, renderItem, onChange }: ContentListItemProps) => {
	const [active, setActive] = useState<any>(null);
	const activeItem = useMemo(() => items.find((item) => item.id === active?.id), [active, items]);

	const [expandedId, setExpandedId] = useState<string>('');

	const sensors = useSensors(
		useSensor(PointerSensor, {
			activationConstraint: {
				distance: 5,
			},
		}),
		useSensor(KeyboardSensor, {
			coordinateGetter: sortableKeyboardCoordinates,
		})
	);

	useEffect(() => {
		const preventPageScroll = () => {
			var x = window.scrollX;
			var y = window.scrollY;
			window.scrollTo(x, y);
		};
		document.addEventListener('scroll', preventPageScroll, false);

		return () => {
			document.removeEventListener('scroll', preventPageScroll, false);
		};
	}, []);

	return (
		<DndContext
			sensors={sensors}
			onDragStart={({ active }) => {
				setActive(active);
			}}
			onDragEnd={({ active, over }) => {
				if (over && active.id !== over?.id) {
					const activeIndex = items.findIndex(({ id }) => id === active.id);
					const overIndex = items.findIndex(({ id }) => id === over.id);

					onChange(arrayMove(items, activeIndex, overIndex));
				}
				setActive(null);
			}}
			onDragCancel={() => {
				setActive(null);
			}}
		>
			<SortableContext items={items}>
				<div
					className="SortableList"
					role="application"
					style={{
						display: 'flex',
						flexDirection: 'column',
						gap: 10,
						padding: '10px 0',
					}}
				>
					{items.map((item) => (
						<React.Fragment key={item.id}>{renderItem(item, expandedId, setExpandedId)}</React.Fragment>
					))}
				</div>
			</SortableContext>
			<SortableOverlay>{activeItem ? renderItem(activeItem) : null}</SortableOverlay>
		</DndContext>
	);
};

export default ContentListItem;
